import { SellerInfo } from "../models/User";

export function conditionData(parsedSellerInfo: SellerInfo) {
    return parsedSellerInfo.conditions == 'true';
}